import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InfoTooltipComponent } from '@ui-kit/miscs/info-tooltip/info-tooltip.component';
import moment from 'moment';
import { map, timer } from 'rxjs';

@Component({
    selector: 'clock-utc',
    imports: [InfoTooltipComponent],
    templateUrl: './clock-utc.component.html',
    styleUrl: './clock-utc.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClockUtcComponent {
    readonly clockUtc = signal(this.formatClockUtc());

    constructor() {
        timer(this.msUntilNextUtcMinute(), 60_000)
            .pipe(
                map(() => this.formatClockUtc()),
                takeUntilDestroyed()
            )
            .subscribe(text => this.clockUtc.set(text));
    }

    private formatClockUtc(): string {
        return moment().format(`MMM D @ HH:mm`);
    }

    private msUntilNextUtcMinute(): number {
        return 60_000 - (Date.now() % 60_000);
    }
}
